import { CustomModal } from "components/CustomModal"
import { useTranslation } from "react-i18next"
import { Box, Button, Typography } from "@strapi/design-system"
import { EmptyPage } from "../EmptyPage"

export const ReEnterIntegration = () => {
  const { t } = useTranslation()
  const integrationURL = "https://tintdemostore.mitiendanube.com/admin/v2/apps"

  const handleIntegrationClick = () => {
    window.location.href = integrationURL
  }

  return (
    <Box>
      <EmptyPage>
        <CustomModal
          isOpen={true}
          title={t("reEnterIntegration.supportTeam")}
          showCloseButton={false}
          startTitleIcon={<img src={"/tint-logo-small.svg"} alt="" />}
        >
          <Box
            hasRadius
            background="neutral0"
            style={{
              maxWidth: "560px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              padding: "10px 0 20px 0",
              alignItems: "center",
            }}
          >
            <Typography variant="beta" textAlign="center">
              {t("reEnterIntegration.reenterAccount")}
            </Typography>

            <Typography variant="epsilon" textAlign="center" marginTop={2}>
              {t("reEnterIntegration.reconnectDescription")}
            </Typography>

            <Box>
              <Button
                onClick={handleIntegrationClick}
                marginTop={4}
                variant="default"
                size="M"
                style={{ width: "100%" }}
              >
                {t("reEnterIntegration.reconnectButton")}
              </Button>
            </Box>
          </Box>
        </CustomModal>
      </EmptyPage>
    </Box>
  )
}
